// src/contexts/loading.provider.tsx
import React, { useState } from 'react';
import LoadingContext, {LoadingProps} from './loading.context';

import LoadingComponent from './loading.tsx';

const LoadingProvider = ({ children }: { children: React.ReactNode }) => {
    const [loadingState, setLoadingState] = useState({
        show: false,
        content: 'loading...',
        mask: false,
    });

    const setLoading = (props: Partial<LoadingProps>) => {
        setLoadingState(prev => ({
            ...prev,
            ...props,
        }));
    };

    return (
        <LoadingContext.Provider value={{ loadingState, setLoading }}>
            {children}
            <LoadingComponent />
        </LoadingContext.Provider>
    );
};

export default LoadingProvider;